import { defineCopy } from '@/i18n'

// Split landing page: Homekind on one side, Mira Solutions on the other
export default defineCopy('home', {
  id: {
    homekind: {
      badge: 'Aplikasi Rumah Tangga · Closed Beta',
      title: { pre: 'Satu aplikasi untuk ', hl: 'semua urusan rumah', post: '' },
      text: 'Keuangan, tagihan, agenda, daftar belanja, dan perawatan rumah dalam satu tempat yang dipakai bersama seisi rumah.',
      chips: {
        budget: 'Kas & Anggaran',
        agenda: 'Agenda',
        shopping: 'Daftar Belanja',
        maintenance: 'Perawatan Rumah',
      },
      open: 'Buka Homekind',
    },
    mira: {
      badge: 'Solusi IT untuk Bisnis',
      title: { pre: 'Pusat solusi IT untuk ', hl: 'bisnis Anda', post: '' },
      text: 'Dari website perusahaan, aplikasi web & mobile, hingga ERP, CRM, dan cloud. Kami bantu bisnis Anda bertransformasi ke era digital.',
      imageAlt: 'Tim Mira Solutions',
      stats: { projects: 'Proyek', years: 'Tahun', support: 'Dukungan' },
      open: 'Buka Mira Solutions',
    },
  },
  en: {
    homekind: {
      badge: 'Household App · Closed Beta',
      title: { pre: 'One app for ', hl: 'everything at home', post: '' },
      text: 'Money, bills, schedules, shopping lists, and home upkeep in one place the whole household shares.',
      chips: {
        budget: 'Money & Budget',
        agenda: 'Agenda',
        shopping: 'Shopping List',
        maintenance: 'Home Maintenance',
      },
      open: 'Explore Homekind',
    },
    mira: {
      badge: 'IT Solutions for Business',
      title: { pre: 'The IT solutions hub for ', hl: 'your business', post: '' },
      text: 'From company websites and web & mobile apps to ERP, CRM, and cloud. We help your business make the move to digital.',
      imageAlt: 'The Mira Solutions team',
      stats: { projects: 'Projects', years: 'Years', support: 'Support' },
      open: 'Explore Mira Solutions',
    },
  },
})
